<script setup lang="ts">
import { usePlannerTemplateForm } from "@/stores/plannerTemplateFormStore";
import TextInput from "@/stories/form/TextInput/TextInput.vue";
import FormContent from "@/views/planner/dialogs/templates/form/FormContent.vue";

const store = usePlannerTemplateForm();
</script>

<template>
  <FormContent>
    <TextInput
      name="title"
      is-required
      :label="$t('templates.form.title')"
      :description="
        $t('global.validation_length', {
          rule: 50,
          current: 50 - (store.form.title?.length || 0),
        })
      "
      :placeholder="$t('templates.form.title_placeholder')"
      :maxlength="50"
      :validation="store.validation"
      v-model="store.form.title"
    />
  </FormContent>
</template>
